import isValidInteger from '../../../utils/numeric/isValidInteger';
import isValidNumber from '../../../utils/numeric/isValidNumber';
export function isInteger(_ref) {
  var schema = _ref.schema;
  return schema.type === 'integer';
}
export function isNumber(_ref2) {
  var schema = _ref2.schema;
  return schema.type === 'number';
}
export function isCurrency(props) {
  return !!getCurrency(props);
}
export function isNumeric(props) {
  return isInteger(props) || isNumber(props);
}
export default isNumeric;
export function isValidNumeric(props, value) {
  if (value.trim().length === 0) {
    return false;
  }
  if (isInteger(props)) {
    return isValidInteger(value);
  }
  if (isNumber(props)) {
    return isValidNumber(value);
  }
  return false;
}
export function getCurrency(props) {
  return props.options.currency;
}